export type WebinarSession = {
  id: string
  /** ISO date (YYYY-MM-DD) of the session, in Eastern Time. */
  date: string
  /** Human-readable start time, including timezone. */
  timeLabel: string
  presenter: string
  registrationUrl: string
}

export type WebinarGroup = {
  id: string
  kind: 'core' | 'supplementary'
  /** Short label used by the filter controls. */
  filterLabel: string
  /** Eyebrow label shown above the group title. */
  eyebrow: string
  title: string
  description: string
  /** Optional summary of the recurring schedule. */
  schedule?: {
    days: string
    time: string
    dateRange: string
  }
  sessions: WebinarSession[]
}

/**
 * Single source of truth for the registration centre.
 * To publish new webinars, edit this array only — the UI is fully derived from it.
 */
export const webinarGroups: WebinarGroup[] = [
  {
    id: 'core',
    kind: 'core',
    filterLabel: 'Core Webinar',
    eyebrow: 'Core Webinar',
    title: 'How to Build, Underwrite and Submit Your Deal in BOSS',
    description:
      'This webinar walks through the complete BOSS workflow from deal creation through underwriting and submission.',
    schedule: {
      days: 'Every Tuesday & Thursday',
      time: '1:00 PM Eastern',
      dateRange: 'September 8 – October 8',
    },
    sessions: [
      {
        id: 'core-sep-8',
        date: '2026-09-08',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Rick Ciampini',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN_KbMG3sy4RtqAGqUAZQuZqQ',
      },
      {
        id: 'core-sep-10',
        date: '2026-09-10',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Nicole Marshall',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN__3me5jlrS7iTciOH07RX6g',
      },
      {
        id: 'core-sep-15',
        date: '2026-09-15',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Victoria Hillier',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN_pV58QJX4RmC9hfd7AFLgJg',
      },
      {
        id: 'core-sep-17',
        date: '2026-09-17',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Rick Ciampini',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN_v7lJ14_PRzKv64cHdz5J6A',
      },
      {
        id: 'core-sep-22',
        date: '2026-09-22',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Victoria Hillier',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN_O-FadxKkRPqgohFy7aHUgA',
      },
      {
        id: 'core-sep-24',
        date: '2026-09-24',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Nicole Marshall',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN_QnXe4BkwRNKtdNEBToVW3A',
      },
      {
        id: 'core-sep-29',
        date: '2026-09-29',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Rick Ciampini',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN_3T3DMJiLTUiq56B3Wl3ToQ',
      },
      {
        id: 'core-oct-1',
        date: '2026-10-01',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Nicole Marshall',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN_fmYjQMLhQz6pe8pe7aHt-w',
      },
      {
        id: 'core-oct-6',
        date: '2026-10-06',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Victoria Hillier',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN_wODH2KKFTKuWQggmaLuVuw',
      },
      {
        id: 'core-oct-8',
        date: '2026-10-08',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Vincent Rochette',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN_q2WE1RZTQR-kN-iS6lHMeg',
      },
    ],
  },
  {
    id: 'supplementary-1',
    kind: 'supplementary',
    filterLabel: 'Supplementary 1',
    eyebrow: 'Supplementary Webinar 1',
    title: 'How to Underwrite Like a BOSS',
    description: 'Customer Portal, Flinks and Simplinsur.',
    sessions: [
      {
        id: 'supp-1-oct-13',
        date: '2026-10-13',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Vincent Rochette',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN_2hFaK_37Q76GXr2qVQcnBg',
      },
      {
        id: 'supp-1-oct-22',
        date: '2026-10-22',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Victoria Hillier',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN_OM2vSPzIS9WsQ5pFjDlz8g',
      },
    ],
  },
  {
    id: 'supplementary-2',
    kind: 'supplementary',
    filterLabel: 'Supplementary 2',
    eyebrow: 'Supplementary Webinar 2',
    title: 'How to Operate Optimally When Underwriting',
    description: 'Customer Journey Board, Tasks and General Notes.',
    sessions: [
      {
        id: 'supp-2-oct-15',
        date: '2026-10-15',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Vincent Rochette',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN_w9Mfi6G0TBOr9N31N7qe4A',
      },
      {
        id: 'supp-2-oct-29',
        date: '2026-10-29',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Nicole Marshall',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN_VeseP1dgRyGJ4ycPR1UAsw',
      },
    ],
  },
  {
    id: 'supplementary-3',
    kind: 'supplementary',
    filterLabel: 'Supplementary 3',
    eyebrow: 'Supplementary Webinar 3',
    title: 'Improvements to the New BOSS Underwriting Experience',
    description:
      'Presentation of the new deal entry workflow and recent underwriting improvements.',
    sessions: [
      {
        id: 'supp-3-oct-20',
        date: '2026-10-20',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Vincent Rochette',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN_ca9A8yOMQgehyQbknzhvuw',
      },
      {
        id: 'supp-3-oct-27',
        date: '2026-10-27',
        timeLabel: '1:00 PM Eastern',
        presenter: 'Rick Ciampini',
        registrationUrl:
          'https://m3-grp.zoom.us/webinar/register/WN_gj9LSO0TSq2qWTfYEWENDQ',
      },
    ],
  },
]
